import config from '../../../config';
export interface IKanbanState {
    kanbanUrl?: string
    kanbanAuthentication?: any
}

export class KanbanState implements IKanbanState {
    kanbanUrl: string;
    kanbanAuthentication: any;

    constructor(options?: IKanbanState) {
        this.kanbanUrl = options?.kanbanUrl || `https://prospection.${config.dev.domain}/`
        this.kanbanAuthentication = options?.kanbanAuthentication || null
    }
}